export default __webpack_public_path__ + "./fonts/lock.23a24f8d.svg";